<script>


import Layout from "../../layouts/auth";
import {
  authMethods,
  authFackMethods,
  notificationMethods,
} from "@/state/helpers";
import { mapState } from "vuex";
import { userService } from '../../../services/authservice/user.service';
import appConfig from "@/app.config";
import { required, email } from "vuelidate/lib/validators";
import Button from "@/components/button";
import Screen from "../../../components/screen";
// import Swal from "sweetalert2";
import i18n from "../../../i18n";

/**
 * Login component
 */
export default {
  extends: Screen,
  page: {
    title: "Login",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    Button,
  },
  data() {
    return {
      // email: "admin@propnavigation.com",
      // password: "123456",
      email: "",
      password: "",
      submitted: false,
      authError: null,
      tryingToLogIn: false,
      isAuthError: false,
    };
  },
  validations: {
    email: {
      required,
      email,
    },
    password: {
      required,
    },
  },
  computed: {
    ...mapState("authfack", ["status"]),
    notification() {
      return this.$store ? this.$store.state.notification : null;
    },
  },
  methods: {
    ...authMethods,
    ...authFackMethods,
    ...notificationMethods,
    // Try to log the user in with the username
    // and password they provided.
    submitLogin() {
       /* eslint-disable no-console */
      this.tryingToLogIn = true;
      userService.login(this.email, this.password)
      .then((data) => {
      
        //  console.log(data);
        if(data && data.access_token !== '') {
          this.tryingToLogIn = false;


          if(data.user!== undefined){
            localStorage.token = data.access_token;
            localStorage.user = JSON.stringify(data.user);
            localStorage.seller = JSON.stringify(data.seller);
            localStorage.user_login = JSON.stringify(data.user_login);
            localStorage.response_people = JSON.stringify(data.response_people);

            this.$router.push(this.$route.query.redirectFrom || {
                name: "dashboard",
            });
          }
        } 

        else if(data.message == 'Invalid Credentials') {


          this.$swal.fire({
              title: i18n.t('authentication.invalid.title'),
              text: i18n.t('authentication.invalid.text'),
              icon: "error",
              confirmButtonText: i18n.t('general.ok')
            });

        
        }

        
      });
      /* eslint-enable no-console */
    },
  },
  mounted() {
    var lsuser_login = localStorage.getItem('user_login');
    const user_login = lsuser_login == 'undefined' ? null :  JSON.parse(lsuser_login);    

    // console.log(JSON.stringify(user));
    if(user_login && user_login.property == 1)  {
      this.$router.push(this.$route.query.redirectFrom || {
              name: "dashboard"
          });
    // } else if(user_login && user_login.management == 1)  {
    //   this.$router.push(this.$route.query.redirectFrom || {
    //           name: "manage-login"
    //       });
    // } else if(user_login && user_login.accounting == 1)  {
    //   this.$router.push(this.$route.query.redirectFrom || {
    //           name: "accounting-login"
    //       });
    }

    // const client = localStorage.getItem('client');
    // if(client == null) {
    //   this.$router.push(this.$route.query.redirectFrom || {
    //             name: "client",
    //         });
    // }

    document.body.className = 'dark-body';
  },
};
</script>

<template>
  <Layout>
    <div class="row justify-content-center">
      <div class="col-md-8 col-lg-6 col-xl-5">
        <div class="card overflow-hidden">
          <div class="bg-soft">
            <br/>
            <div class="row" style="background-color: #fff">
              <div class="col-md-4">
                <!-- <div style="background-color: yellow"> 2a3143-->
                  <div class="avatar-md mb-4">
                    <span style="margin-left:30px; padding: 10px">
                      <img src="@/assets/images/logo-light.svg" height="100"/>
                    </span>
                  </div>
                <!-- </div> -->
              </div>
              <div class="col-md-8">
                <div class="text-primary p-4">
                  <h5 class="text-primary" style="color: #2a3143 !important;">{{$t('menuitems.general.welcome')}}</h5>
                  <p style="color: #2a3143 !important;">{{$t('menuitems.authentication.list.logintext')}}</p>
                </div>
              </div>
            </div>

            <!-- <div class="row">
              <div class="col-12">
              
                <div class="col-5">
                  <div class="avatar-md mb-4">
                    <span class="avatar-title rounded-circle bg-light" style="background-color: #2A3143 !important;">
                      <img src="@/assets/images/logo.svg" alt height="34" />
                    </span>
                  </div>
                </div>
                <div class="col-7">
                  <div class="text-primary p-4">
                    <h5 class="text-primary">{{$t('menuitems.general.welcome')}}</h5>
                    <p>{{$t('menuitems.authentication.list.logintext')}}</p>
                  </div>
                </div>
              </div>
            </div> -->
          </div>
          <div class="card-body pt-0">
            <!-- <div>
              <router-link tag="a" to="/">
                
              </router-link>
            </div> -->
            <b-alert
              v-model="isAuthError"
              variant="danger"
              class="mt-3"
              dismissible
              >{{ authError }}</b-alert
            >

            <div
              v-if="notification.message"
              :class="'alert ' + notification.type"
            >
              {{ notification.message }}
            </div>

            <b-form class="p-2" @submit.prevent="submitLogin">
              <b-form-group
                class="mb-3"
                id="input-group-1"
                v-bind:label="$t('menuitems.authentication.list.username-email')"
                label-for="input-1"
              >
                <b-form-input
                  id="input-1"
                  v-model="email"
                  type="text"
                  v-bind:placeholder="`${$t('menuitems.general.enter')}${$t('menuitems.authentication.list.username-email')}`"
                  :class="{ 'is-invalid': submitted && $v.email.$error }"
                ></b-form-input>
                <div
                  v-if="submitted && $v.email.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.email.required">Email is required.</span>
                  <span v-if="!$v.email.email">Please enter valid email.</span>
                </div>
              </b-form-group>

              <b-form-group
                class="mb-3"
                id="input-group-2"
                v-bind:label="$t('menuitems.authentication.list.password')"
                label-for="input-2"
              >
                <b-form-input
                  id="input-2"
                  v-model="password"
                  type="password"
                  v-bind:placeholder="`${$t('menuitems.general.enter')}${$t('menuitems.authentication.list.password')}`"
                  :class="{ 'is-invalid': submitted && $v.password.$error }"
                ></b-form-input>
                <div
                  v-if="submitted && !$v.password.required"
                  class="invalid-feedback"
                >
                  {{`${$t('menuitems.authentication.list.password')} ${$t('menuitems.general.isrequired')}`}}
                </div>
              </b-form-group>
              <div class="mt-3 d-grid">
                <!-- <b-button type="submit" variant="primary" class="btn-block" ref="submit">
                  Log In
                </b-button> -->
                <Button v-bind:icon="'bx bx-lock bx-tada'" 
                  v-bind:title="$t('menuitems.authentication.list.login')"
                  v-bind:requesting="tryingToLogIn" />
              </div>
              
              <div class="mt-4 text-center">
                <router-link tag="a" to="/forgot-password" class="text-muted">
                  <i class="mdi mdi-lock me-1"></i> 
                  {{$t('menuitems.authentication.list.forgotyourpwd')}}
                </router-link>
              </div>
            </b-form>
          </div>
          <!-- end card-body -->
        </div>
        <!-- end card -->

        <div class="mt-5 text-center">
          <p>
            © {{ new Date().getFullYear() }} Properties Navigation.
          </p>
        </div>
        <!-- end row -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>

<style lang="scss" module></style>
